import React from 'react';
import PropTypes from 'prop-types';
import { createComponent } from '@cloudflare/style-container';
import ScrollContainer from './ScrollContainer';

var MenuWrapper = createComponent(function (_ref) {
  var theme = _ref.theme;

  return {
    border: '1px solid ' + theme.colors.gray[5],
    borderRadius: theme.borderRadius,
    backgroundColor: theme.colors.white,
    marginTop: '5px',

    boxSizing: 'border-box',
    position: 'absolute',
    top: '100%',
    minWidth: '100%',
    maxWidth: '350px',
    zIndex: '1100',
    webkitOverflowScrolling: 'touch'
  };
});
MenuWrapper.setDisplayName('MenuWrapper');

export default function menuRenderer(_ref2, _ref3) {
  var focusedOption = _ref2.focusedOption,
      instancePrefix = _ref2.instancePrefix,
      onFocus = _ref2.onFocus,
      onSelect = _ref2.onSelect,
      optionComponent = _ref2.optionComponent,
      optionRenderer = _ref2.optionRenderer,
      options = _ref2.options,
      valueArray = _ref2.valueArray,
      valueKey = _ref2.valueKey,
      onOptionRef = _ref2.onOptionRef;
  var menuTitle = _ref3.menuTitle,
      closeMenu = _ref3.closeMenu,
      closeMenuComponent = _ref3.closeMenuComponent,
      menuHeaderComponent = _ref3.menuHeaderComponent;

  var MenuHeader = menuHeaderComponent;
  var CloseMenu = closeMenuComponent;
  var Option = optionComponent;

  var opts = options.map(function (option, i) {
    var isSelected = valueArray && valueArray.indexOf(option) > -1;
    var isFocused = option === focusedOption;

    return React.createElement(
      Option,
      {
        instancePrefix: instancePrefix,
        isDisabled: option.disabled,
        isFocused: isFocused,
        isSelected: isSelected,
        onFocus: onFocus,
        onSelect: onSelect,
        option: option,
        optionIndex: i,
        ref: function ref(_ref4) {
          onOptionRef(_ref4, isFocused);
        },
        key: 'option-' + i + '-' + option[valueKey]
      },
      optionRenderer(option, i)
    );
  });

  return React.createElement(
    MenuWrapper,
    null,
    menuTitle && React.createElement(
      MenuHeader,
      null,
      React.createElement(
        'span',
        null,
        menuTitle
      ),
      React.createElement(CloseMenu, { closeMenu: closeMenu })
    ),
    React.createElement(
      ScrollContainer,
      null,
      opts
    )
  );
}

menuRenderer.propTypes = {
  focusedOption: PropTypes.object,
  instancePrefix: PropTypes.string,
  onFocus: PropTypes.func,
  onSelect: PropTypes.func,
  optionComponent: PropTypes.element,
  optionRenderer: PropTypes.func,
  options: PropTypes.array,
  valueArray: PropTypes.array,
  valueKey: PropTypes.string,
  onOptionRef: PropTypes.func
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-select/es/menuRenderer.js
// module id = 1113
// module chunks = 1